import { Platform } from 'react-native';

import { jsonForHtmlScript } from '../lib/staticNewsContent';

export default function StaticJsonScript({ id, value }: { id: string; value: unknown }) {
    if (Platform.OS !== 'web' || value == null) return null;

    return (
        <script
            id={id}
            type="application/json"
            dangerouslySetInnerHTML={{ __html: jsonForHtmlScript(value) }}
        />
    );
}
